import React from 'react'
import { Calendar, CalendarOff } from 'lucide-react'

// Staff Availability — placeholder until a real availability backend exists.
// The previous version generated fake random schedules client-side and showed
// a fake "saved" toast; that dishonest behavior was removed (2026-07-09).

interface FleetStaff {
  id: number
  staff_code: string
  full_name: string
  staff_type: string
  employment_status: string
  shift_pattern: string
}

interface StaffAvailabilityProps {
  staff: FleetStaff[]
  selectedStaff?: FleetStaff | null
  showMessage?: (message: string, type?: 'success' | 'error' | 'warning' | 'info') => void
}

const StaffAvailability: React.FC<StaffAvailabilityProps> = ({ selectedStaff }) => {
  return (
    <div className="h-full bg-white flex flex-col">
      {/* Header */}
      <div className="border-b border-gray-200 p-6 flex-shrink-0">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
          <Calendar className="w-5 h-5 text-blue-600" />
          <span>Disponibilité du Personnel</span>
        </h3>
        <p className="text-gray-600 mt-1">
          {selectedStaff
            ? `Planification pour ${selectedStaff.full_name}`
            : "Vue d'ensemble de la disponibilité de l'équipe"}
        </p>
      </div>

      {/* Honest empty state — no availability backend yet */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <CalendarOff className="w-14 h-14 text-gray-300 mx-auto mb-4" />
          <h4 className="text-lg font-medium text-gray-900 mb-2">
            Suivi de disponibilité non activé
          </h4>
          <p className="text-sm text-gray-600">
            La planification des équipes (shifts, congés, affectations journalières)
            n'est pas encore suivie par la plateforme. Cette fonctionnalité sera
            disponible lorsque le module de planification sera mis en service.
          </p>
        </div>
      </div>
    </div>
  )
}

export default StaffAvailability
